module.exports = __webpack_public_path__ + "static/media/topography.bdc1c122.svg";